import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-xs p-1 opacity-60"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" This ")
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" was taken by ")
const _hoisted_5 = ["href"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" on ")
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/_createTextVNode(". ")

import { ImageInfo } from "@/ImageInfo";


export default /*#__PURE__*/_defineComponent({
  props: {
  image: ImageInfo,
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.image?.attribution)
    ? (_openBlock(), _createElementBlock("p", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("a", {
          class: "text-palette2",
          href: __props.image?.attribution.goToUrl
        }, "Photo", 8, _hoisted_3),
        _hoisted_4,
        _createElementVNode("a", {
          class: "text-palette2",
          href: __props.image?.attribution.authorUrl
        }, _toDisplayString(__props.image.attribution.author), 9, _hoisted_5),
        _hoisted_6,
        _createElementVNode("a", {
          class: "text-palette2",
          href: __props.image?.attribution.website
        }, _toDisplayString(__props.image.attribution.websiteName), 9, _hoisted_7),
        _hoisted_8
      ]))
    : _createCommentVNode("", true)
}
}

})